export const defaultMarkerIODestination =
  process.env.REACT_APP_MARKER_IO_DESTINATION;
export const showProductionWarning =
  !!process.env.REACT_APP_SHOW_PRODUCTION_WARNING && !window.Cypress;
export const isLocalDevServer = process.env.NODE_ENV === "development";
const databaseSwitcherDomainsCsv =
  process.env.REACT_APP_FEATURE_DATABASE_SWITCHER_DOMAINS_CSV;
export const databaseSwitcherDomains = databaseSwitcherDomainsCsv
  ? databaseSwitcherDomainsCsv.split(",")
  : [];
export const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
export const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
export const sentryTracesSampleRate =
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE;

export const frontendBaseUrl =
  window.location.protocol + "//" + window.location.host;

export const isRunningInTest = process.env.JEST_WORKER_ID !== undefined;

export const warehouseImagesBaseUrl =
  process.env.REACT_APP_WAREHOUSE_IMAGES_FILES_URL ??
  "https://d364izy8ku545l.cloudfront.net";

export const insightoutAiEndpoint =
  process.env.REACT_APP_INSIGHTOUT_AI_ENDPOINT ??
  "https://dev.ai.api.ttgda.com";

export const aiDryRun =
  process.env.REACT_APP_AI_DRY_RUN && process.env.REACT_APP_AI_DRY_RUN !== "0";

export const paginationLimitDefault = Number(
  (isRunningInTest ? "" : process.env.REACT_APP_PAGINATION_LIMIT_DEFAULT) ||
    "1000"
);
export const paginationLimitMax = Number(
  (isRunningInTest ? "" : process.env.REACT_APP_PAGINATION_LIMIT_MAX) || "2500"
);
